var app = angular.module('storefrontApp');
app.controller('frequentlyBoughtTogetherController', 
    ['$rootScope', '$scope', '$window','elasticService',"cartService","commonService", "configs",
    function ($rootScope, $scope,$window, elasticService,cartService, commonService, configs) {

        $scope.productsPool = [];
        $scope.productSummary = [];

        $scope.totallistPrice = 0;
        $scope.totalsalePrice = 0;
        $scope.totalclubPrice = 0;

        $scope.generateGuid = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };
      
        $scope.getItemPacks = function(prdId,catalog) {
            $rootScope.showLoader = true;
            commonService
                .getFrequentlyBoughtProducts(prdId,catalog)
                .then(function (response) {
                    if(response &&
                        response.data &&
                        response.data.isActive === true &&
                        response.data.mappedAssociatedItems != undefined &&
                        response.data.mappedAssociatedItems !== null &&
                        response.data.mappedAssociatedItems.trim() !== ""
                    ){

                        var data = response.data;
                        $scope.productsPool = data.mappedAssociatedItems.split(",");
                        $scope.seriesId = $scope.generateGuid();
                        $scope.discountRate = response.data.discountRate;
                        commonService
                            .getElasticData(configs.elasticBaseUrl,
                                elasticService.buildProductInfoRequest(
                                    $scope.productsPool,
                                    true
                                )
                            )
                            .then(function (responseData) {
                                if (
                                    responseData &&
                                    responseData.data &&
                                    responseData.data.hits &&
                                    responseData.data.hits.hits.length > 0
                                ) {
                                    $scope.productInfo =
                                        responseData.data.hits.hits;

                                    for (
                                        var i = 0;
                                        i < $scope.productInfo.length;
                                        i++
                                    ) {
                                        if(angular.isDefined($scope.productInfo[i]) && angular.isDefined($scope.productInfo[i]._source)){
                                            var product = $scope.productInfo[i]._source;
                                            var salePrice = !isNaN(product.salePrice) ? parseFloat(product.salePrice) : 0; // Convert to number or set to 0 if NaN
                                            var discountRate =  parseFloat($scope.discountRate); // Convert to number or set to 1 if NaN (to avoid division by zero)
                                            var calculatedSalePrice = salePrice !== 0 ? salePrice - (salePrice / discountRate) : product.listPrice - (product.listPrice / discountRate);
                                            var clubPrice = !isNaN(product.clubPrice) ? parseFloat(product.clubPrice) : salePrice;
                                            var calculatedClubprice = clubPrice !== 0 ? clubPrice - (clubPrice / discountRate) : calculatedSalePrice;

                                            if(calculatedClubprice > calculatedSalePrice){
                                                calculatedClubprice = calculatedSalePrice;
                                            }
                                            $scope.totallistPrice += salePrice !== 0 ? salePrice : product.listPrice;
                                            $scope.totalsalePrice += calculatedSalePrice;
                                            $scope.totalclubPrice += calculatedClubprice;
                                            product.listPrice = salePrice !== 0 ? salePrice : product.listPrice;
                                            
                                            $scope.productInfo[i]._source = product; 
                                            $scope.productInfo[i].selected = true;
                                            // Push this object into the summary array
                                            $scope.productSummary.push($scope.productInfo[i]);
                                        }
                                    }

                                    $rootScope.showLoader = false;
                                }
                            });
                    } 
                });
                
        };

        $scope.addMultipleItemToCart = function () {
            var addItemPromises = $scope.productSummary.map(function (item) {
                return $scope.addItemToCart(item);
            });
            Promise.all(addItemPromises).then(function () {
                $rootScope.showLoader = false;
                $window.location.href = "/cart";
            })
        };

        $scope.addItemToCart = function (item) {
            $rootScope.showLoader = true;
                if (item) {
                   return cartService
                        .addMultipleProductsAsLineItems(item._id, 1,$scope.seriesId)
                        .then(function (response) {
                            if (
                                response &&
                                response.data &&
                                response.data.itemAdded
                            ) {
                                $rootScope.$broadcast('CustomerCartChanged');
                            }
                           
                           return response;
                        })
                        .catch(function (error) {
                            $rootScope.showLoader = false;
                            return Promise.reject(error); 
                        });;
                } else {
                    $rootScope.showLoader = false;
                    return Promise.resolve();
                }
            
        };

        $scope.checkedItems = function () {
            $scope.listPrice1 = 0;
            $scope.salePrice1 = 0;
            var checkedItemsPrice = $scope.productSummary.filter(function (
                prdcheck
            ) {
                return prdcheck.selected === true;
            });
            checkedItemsPrice.forEach(function (itemprice) {
                $scope.listPrice1 += parseFloat(itemprice.listPrice);
                if (angular.isDefined(itemprice.salePrice)){
                    $scope.salePrice1 += parseFloat(itemprice.salePrice);
                }
            });
        };
    }
]);